// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Notifier le client de sauter",
  "1d484fee4a": "Département des finances, Département des ventes, Gestion de projet, Données opérationnelles, Département de la production, Département des opérations, Gestion de la recherche et développement, Plan de version, Département du service clientèle, Département administratif, Département des achats, Gestion après-vente",
  "a2c88dfb79": "Créez Votre Premier Équipe",
  "3cfdcc6086": "Département des finances, département des ventes, gestion de projet/305, administratif et RH/306, département des opérations, gestion de la R&D, planification des versions, gestion du service clientèle/403, département des achats, gestion après-vente",
  "ac45ec2c05": "Échec de la vérification du compte de connexion",
  "9aef9b8ccd": "Anomalie avec le compte actuellement connecté, veuillez re-connecter votre compte et essayer",
  "728dd00f22": "Anomalie de vérification avec ce numéro de téléphone, veuillez essayer de vous connecter avec un code de vérification par SMS",
  "30dbecd916": "Vos informations saisies contiennent des mots sensibles, veuillez modifier et réessayer",
  "12ed508d8a": "Vous effectuez des opérations trop fréquentes, veuillez réessayer plus tard",
  "952d4a7595": "État de connexion du compte actuel anormal, veuillez re-connecter votre compte et essayer",
  "e64bfdeaa4": "Échec de la vérification de connexion, veuillez obtenir à nouveau le code SMS",
  "79008a65f1": "Ce numéro de téléphone est associé à plusieurs entreprises, veuillez vous connecter à une entreprise ou changer de numéro de téléphone",
  "bf242eff42": "Le nom d'entreprise existe déjà",
  "4f0cdb8374": "Veuillez entrer un numéro de téléphone complet, si vous utilisez un numéro de l'étranger, veuillez le remplacer par un numéro local (86+)",
  "46e79ffeff": "Anomalie lors de la création de l'entreprise, veuillez contacter le service client officiel pour résoudre",
  "f3e18f0341": "Échec de la validation des paramètres",
  "503fd1718d": "Échec de l'envoi du code SMS",
  "24b3129f19": "Les SMS sont envoyés trop fréquemment, veuillez réessayer plus tard",
  "1cde3e8245": "Le code de vérification est incorrect, veuillez le resaisir",
  "4212ecc031": "Il y a eu plusieurs erreurs de vérification, la vérification est temporairement restreinte, veuillez réessayer plus tard",
  "735da9c347": "Anomalie de vérification de doublon de nom d'entreprise, veuillez contacter le service client officiel pour résoudre",
  "8731da9615": "Anomalie de vérification d'authentification de nom d'entreprise, veuillez contacter le service client officiel pour résoudre",
  "62e89b3f16": "Accepter l'accord de service",
  "c9b79027e5": "Envoyer le code de vérification",
  "84c1447b9d": "Copie réussie",
  "fba4b0abd0": "Enregistrement de l'hôte",
  "37f5a7cd41": "Valeur TXT",
  "78b12427c9": "Vérification en cours...",
  "59d089837c": "Nous ne pouvons actuellement pas vérifier votre domaine, vous devrez peut-être attendre un certain temps pour que l'hébergeur de domaine mette à jour vos informations. Si aucune réponse après un certain temps, veuillez essayer de vérifier à nouveau, ou changer de domaine.",
  "4a5b7383d1": "Vérification du nom de domaine en cours",
  "f24a492e40": "des enregistrements de validation, vous pouvez fermer cette page et revenir plus tard pour vérifier.",
  "c697ca5f1a": "Bienvenue à l'édition Entreprise",
  "ebb01b1740": "Suivant",
  "30109bf753": "Votre entreprise a-t-elle un nom de domaine?",
  "2b3e485b47": "J'ai un nom de domaine d'entreprise",
  "1a7f5eae44": "Je n'ai pas de nom de domaine d'entreprise",
  "bde15d6d84": "Vous devez disposer d'un nom de domaine (par exemple, example.com) pour pouvoir créer un compte entreprise pour vous",
  "07ffb22c90": "Désolé, vous devez avoir un nom de domaine pour créer un compte entreprise pour votre entreprise",
  "de23836563": "Veuillez entrer le nom de domaine à utiliser pour créer le compte entreprise",
  "287c07944a": "Vérifiez votre nom de domaine",
  "3ea2d528d5": "Suivez les étapes ci-dessous pour prouver que vous êtes le propriétaire de <b>{domain}</b> et empêcher toute autre personne d'utiliser ce domaine pour enregistrer un compte entreprise.",
  "082b18ce56": "a. Ouvrez le site Web de votre fournisseur d'hébergement de domaine dans un <b>nouvel onglet</b>, puis <b>connectez-vous</b> à votre compte;",
  "4f7e0841a9": "b. Sur le site Web de votre fournisseur d'hébergement de domaine, accédez à la <b>section des enregistrements DNS</b>. Sur le site Web de votre fournisseur d'hébergement de domaine, le nom de la section des enregistrements DNS peut varier, comme indiqué en tant que <b>Gestion DNS (DNS Management), Gestion du serveur de noms (Name Server Management), Panneau de contrôle (Control Panel) ou Paramètres avancés (Advanced Settings).</b>",
  "6365ad6e3a": "Ensuite, <b>revenez ici</b>, puis cliquez sur « Suivant » pour ajouter une entrée de vérification.",
  "8528892080": "Ajouter l'enregistrement de vérification",
  "7a225304f8": "a. Sur la page DNS, faites défiler jusqu'à la section <b>TXT</b> et cliquez sur le bouton approprié pour ajouter un enregistrement;",
  "b3cb7d947c": "b. <b>Copiez et collez</b> toutes les valeurs ci-dessous dans le <b>formulaire TXT</b> du site Web de votre fournisseur d'hébergement de domaine;",
  "47213583bf": "c. <b>Sauvegardez</b> les enregistrements sur le site web de votre fournisseur d'hébergement de domaine, <br> puis <b>revenez ici</b> et cliquez sur « Authentifier le domaine » ci-dessous",
  "21486a57cf": "Remarque : Dans les champs Nom/Hôte/Alias, vous pouvez entrer « @ » ou le laisser vide. Votre fournisseur d'hébergement de domaine peut également vous demander d'entrer le domaine (votre domaine.com) dans ce champ. Vous pouvez vous référer à d'autres enregistrements DNS pour déterminer ce qu'il faut entrer dans ce champ. Dans le champ Time to Live (TTL), entrez « 86400 » ou laissez la valeur par défaut.",
  "f1b8edab9c": "Changer le domaine",
  "7c6fc663a8": "Authentifier le domaine",
  "b6aee9dc0d": "Vérification du domaine réussie",
  "dd4cc429ea": "Vous avez prouvé être le",
  "450f5c9230": "propriétaire et interdit à toute autre personne d'utiliser ce domaine pour enregistrer un compte d'entreprise.",
  "71cbcba755": "Cliquez sur 'Suivant' pour terminer la création du compte entreprise.",
  "f4084f4870": "Veuillez définir votre compte de connexion",
  "fe3138baec": "Terminer la création",
  "0315cddedb": "Création de l'entreprise réussie",
  "91454a7f34": "Connectez-vous maintenant au tableau de bord pour créer des comptes entreprise pour les membres de votre entreprise.",
  "366304cde7": "1. Vous serez automatiquement déconnecté du compte WPS actuel",
  "8a9f2a8422": "2. Vous devez vous connecter à l'administration avec votre compte d'entreprise {account}@{domain}",
  "43e265e998": "Connectez-vous au tableau de bord",
  "9240efaaf0": "Message envoyé",
  "e424bb9a6d": "Veuillez entrer",
  "d44d581706": "le nom de l'entreprise",
  "aa8679f406": ", de 4 à 30 caractères",
  "581bdb1f98": "Ne peut pas contenir de symboles spéciaux \\ / : * ? \" <> | {}",
  "c13cabb67a": "Email",
  "2b9b429e46": "Votre email",
  "5ed834a7df": "Veuillez entrer votre email",
  "acfd1f02ed": "Veuillez entrer un email valide",
  "31c7c92cca": ", jusqu'à 80 caractères",
  "3f27cf84b3": "Veuillez entrer le code de vérification",
  "a0ae1f3ec4": "Code de vérification incorrect",
  "e5589c5e74": "Votre nom",
  "69d7bd63f6": ", uniquement des caractères chinois, lettres ou chiffres",
  "91f008d258": ", jusqu'à 8 caractères",
  "6ea6c9b39b": "Numéro de téléphone",
  "161042c5b7": "Veuillez entrer votre numéro de téléphone",
  "e6b8eab1cd": "Veuillez entrer un numéro de téléphone de 11 chiffres",
  "3fd5fbb3cc": "Veuillez entrer votre domaine",
  "cb5346ba8e": "Veuillez entrer un domaine d'entreprise valide, de 4 à 30 caractères",
  "27928eb7a4": "Nom d'utilisateur",
  "8e19bd444d": "Veuillez entrer le nom d'utilisateur pour vous connecter",
  "7bbbf479dc": "4-20 caractères, uniquement des chiffres, des lettres ou des soulignements",
  "3d84cae479": "Veuillez entrer un compte valide dont le premier caractère doit être une lettre ou un chiffre",
  "c0d5ece1a7": "Mot de passe",
  "f444036fa8": "Veuillez entrer le mot de passe",
  "b03218d72b": "Le mot de passe doit comporter 12 à 16 caractères, combinant majuscules, minuscules et chiffres",
  "b4ab05df50": "* Un membre de votre organisation a déjà utilisé votre domaine pour un compte d'entreprise, veuillez contacter le service client (400-677-5005) pour prouver que vous possédez ce domaine",
  "c58876008f": "Échec de la copie, veuillez réessayer",
  "86f73420de": "Lien d’invitation",
  "a58861962c": "Désolé, votre navigateur ne prend pas en charge le téléchargement de ce code QR",
  "228db07f78": "Finance, ventes, gestion de projet, données commerciales, département des produits, département des opérations, gestion de la recherche et développement, planification des versions, service à la clientèle, administration, achats, gestion après-vente",
  "93896d7e98": "Après avoir créé une équipe, commencez à collaborer avec vos collègues",
  "e8f66fb75c": "Finance, ventes, gestion de projet/305, administration du personnel/306, département des opérations, gestion de la recherche et développement, planification des versions, gestion du service à la clientèle/403, achats, gestion après-vente",
  "831b73da9b": "Les noms ne peuvent pas contenir de caractères illégaux et de symboles spéciaux /\\;:*?\"<>|%&",
  "51ab33b3ee": "Paramètre incorrect",
  "a297f9e951": "Nom de l’entreprise en double",
  "04d60ed5f5": "Utilisation de mots interdits n’est pas autorisée",
  "2ff7bef083": "Format de domaine incorrect",
  "41e1ba2165": "Échec de la vérification des informations TXT du domaine",
  "50f348caa9": "Compte en double",
  "9d4c950d65": "Ce nom est déjà enregistré",
  "38cf19ed95": "Le nom de cet organisme existe déjà",
  "4b426e7c9c": "Nom de l’organisme",
  "298f880e18": "Existe déjà, nous vous suggérons d’ajouter plus d’informations :",
  "1e67dd20b3": "Récupérer le nom de l’organisme",
  "517107cb04": "Utiliser un autre nom",
  "5667081882": "Créer avec ce nom",
  "e306a979a6": "Remplissage rapide :",
  "f583db96e0": "* Si le nom de l’organisme est pris, vous pouvez",
  "9767148e34": "Veuillez entrer le nom de votre entreprise ou organisation, entre 4 et 100 caractères",
  "e0e0ec159f": "Nom de l’organisme",
  "5b13d254c0": "Ce nom d’entreprise existe déjà",
  "92027671ec": "Nom de l’entreprise",
  "36d482a7fb": "Récupérer le nom de l’entreprise",
  "79058a7577": "* Si le nom de l’entreprise est pris, vous pouvez",
  "c96dd48dba": "Nom de l’entreprise",
  "842efad336": "* Si vous êtes un employé de l’entreprise, veuillez",
  "860f9bd77b": "contacter le service client",
  "5a7ed18daf": "Rejoindre l’entreprise",
  "ab470e9ace": "Informations de contact réservées",
  "0a7e0e48a7": "Nom de l’entreprise à rejoindre :",
  "a8dc318dcc": "Veuillez vérifier vos informations de contact, le service client vous contactera bientôt",
  "6ea1f4d7f5": "Soumettre les informations",
  "d439e39f43": "Vos informations ont été reçues",
  "884653426b": "Le service client vous appellera dans un délai de 24 heures, veuillez prêter attention à l'appel !",
  "2361cb14bf": "Scannez le code WeChat pour ajouter un service client en ligne et connaître l'avancement",
  "50f45d0031": "Échec de la sauvegarde",
  "fc856d0fd2": "Super Administrateur",
  "e16c0676d2": "Administrateur",
  "b1d2ddd126": "Membre Ordinaire",
  "9d322cc08d": "Nom d'institution ne peut pas contenir de symboles spéciaux \\/:*?\"<>|{}",
  "b583ba7363": "Nom d'entreprise ne peut pas contenir de symboles spéciaux \\/:*?\"<>|{}",
  "1d118a9bad": "Le nom de l'institution doit comporter au moins 4 caractères, veuillez entrer un nom composé de 4 à 100 caractères",
  "441b45b1f5": "Le nom de l'entreprise doit comporter au moins 4 caractères, veuillez entrer un nom composé de 4 à 100 caractères",
  "97457cb1f0": "Le nom de l'institution dépasse 100 caractères, veuillez entrer un nom composé de 4 à 100 caractères",
  "8ce00d3b92": "Le nom de l'entreprise dépasse 100 caractères, veuillez entrer un nom composé de 4 à 100 caractères",
  "a72778d3de": "Le prénom doit comporter au moins 2 caractères, veuillez entrer un prénom composé de 2 à 10 caractères",
  "79c17db5de": "Le prénom dépasse 10 caractères, veuillez entrer un prénom composé de 2 à 10 caractères",
  "482a118202": "Le prénom n'accepte que les caractères chinois, les chiffres, l'anglais et le point médian",
  "9a9be18941": "Veuillez cocher",
  "e6b7c4aa66": "Accord de service en ligne",
  "595023d905": "Créer une institution",
  "ba8c2df551": "Créer une entreprise",
  "d284384975": "Accord de service en ligne",
  "5c266d5a84": "Politique de confidentialité",
  "fcb92dbcf6": "Accord de service cloud",
  "2ae7a8a3f7": "Merci d'avoir choisi WPS 365 pour les services cloud. Ce qui suit présente l'accord juridique entre vous et/ou l'organisation que vous représentez et Kingsoft concernant l'inscription, l'abonnement, et l'utilisation de ce service.",
  "d30a6983bd": "Veuillez lire {0} | {1} | {2}, cliquer sur «Accepter», ce sera considéré comme une acceptation du contenu de l'accord et de l'acceptation de nos services.",
  "263e306ede": "J'ai lu et j'accepte {0} | {1} | {2}",
  "440129c0f1": "Veuillez entrer {0}",
  "8ab916983d": "Nom de l'entreprise",
  "b01d68543b": "Votre nom",
  "684b30d4e9": "Votre numéro de téléphone",
  "a48427e8e2": "Utilisé pour établir une plateforme de travail appartenant à votre entreprise",
  "3a81b0f1fc": "Pour que vos collègues puissent vous trouver dans le système et collaborer",
  "52bc539b6e": "Confirmer la création",
  "b2fe245e19": "Créer une entreprise/équipe : Partage et collaboration de fichiers",
  "893282d3f7": "Veuillez compléter les informations de l'entreprise:",
  "cc997bf6aa": "Confirmer",
  "50fdde51ac": "{0}, entre {1} et {2} caractères",
  "a19cc5ec18": "{0} ne peut pas contenir de symboles spéciaux \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, ne permet que les caractères chinois, lettres et chiffres",
  "f4080b1431": "{0}, maximum {1} caractères",
  "88e59b2d58": "{0}, 11 chiffres",
  "91d6d4e105": "Entrez le code de vérification",
  "bec71bde96": "Code de vérification incorrect",
  "e20ff8ee19": "{0} obligatoire",
  "8dc09d10d7": "dwId introuvable",
  "a03766ce6c": "École",
  "03542addfe": "Entreprise",
  "adb8a815d1": "Limite atteinte de lier le numéro de téléphone à {0}",
  "97a6b66f1d": "Le numéro de téléphone actuel est déjà lié à {0}",
  "665e465487": "Impossible de créer {0}, le numéro de téléphone actuel « <strong>{1}</strong> » a atteint la limite du nombre {0} pouvant être lié (maximum de 5 {2} autorisés). Vous pouvez accéder aux éléments de {3} déjà liés :",
  "a85b1367ca": "Le numéro de téléphone actuel «{0}» est déjà lié à {1}, vous pouvez choisir de vous connecter avec {2} existant ou créer un nouveau {3} :",
  "bf992ce17b": "Utiliser un autre numéro de téléphone pour créer {0}",
  "395ea04444": "Créer un nouveau {0}",
  "4ce3bb86b3": "Limite atteinte de ma participation à {0}",
  "df88c4b7a5": "Le numéro de téléphone actuel «{0}» est déjà lié à la quantité maximale de {1}",
  "78f7dd59ca": "Le numéro de téléphone actuel «{0}» est lié aux {1} suivants, vous pouvez basculer directement pour les utiliser",
  "8db491a3f8": "Continuez à créer un nouveau {0}",
  "83f6d9e1e4": "Encore une fois",
  "1dc5f11612": "Ou",
  "217d76f53e": "Répondre aux questions",
  "b69a6ea62a": "Veuillez maintenir le bouton gauche de la souris pour révéler les deux boucliers",
  "3a31f64800": "Félicitations, vous avez réussi à révéler le bouclier<br/>Continuez avec l'étape suivante",
  "6a81fcee96": "Chargement",
  "e97877a65d": "Oh, le bouclier a disparu<br/>Veuillez",
  "8d85456145": "J'attends depuis trop longtemps<br/>Veuillez",
  "77ad847b95": "Connexion réseau très faible<br/>Veuillez",
  "dbd1ae3a34": "Vous avez gratté trop vite<br/>Veuillez",
  "bd8e05cd53": "Cliquez sur le bouton pour démarrer la vérification intelligente",
  "63d2a8a722": "Vérification réussie",
  "73141928ad": "Échec de la vérification, veuillez cliquer sur le bouton pour actualiser",
  "04856c5c8a": "Détection intelligente en cours",
  "52cd9bd26d": "Votre action n'est pas autorisée",
  "fd157e8ea8": "Guide de création",
  "c6225c5b2b": "Bienvenue dans la version entreprise",
  "e33423fb1e": "Création réussie",
  "7b0c035999": "Page de création réussie de Docs entreprise de Kingsoft",
  "85db8faae0": "Instructions d'utilisation de la version entreprise",
  "20591b9b44": "Récupérer le nom de l'entreprise",
  "b023d76dc2": "Guide de téléchargement des membres",
  "e2f454e095": "Entreprise de {0}",
  "df466f942b": "Division",
  "26a7b797c4": "Centre de branche",
  "5fc82b360b": "Plateforme de services de bureau tout-en-un, pour une efficacité de travail accrue",
  "f2e736d52e": "Bienvenue dans la version entreprise",
  "becc41a35b": "Nom de l'entreprise",
  "74685cdc58": "Veuillez entrer le nom de l'entreprise ou de l'organisation, entre 4 et 100 caractères",
  "07b55b1907": "Taille de l'entreprise",
  "77b2f763ad": "Veuillez choisir la taille de votre entreprise",
  "49d2509109": "Moins de 5 personnes",
  "8db2c9b74a": "6-20 personnes",
  "a9fb0cf14a": "21-50 personnes",
  "0fed41f8d3": "51-100 personnes",
  "fb33f25a04": "101-200 personnes",
  "3e3ff0f52e": "201-500 personnes",
  "cd8b51f634": "501-2000 personnes",
  "0662fa6eec": "Plus de 2000 personnes",
  "69334dba1a": "Besoins de l'entreprise",
  "79994e749c": "(Nous recommanderons les meilleures pratiques du secteur pour l'entreprise)",
  "840a017f38": "Veuillez choisir le problème que vous souhaitez le plus résoudre",
  "f045b05c73": "Veuillez entrer vos besoins pour créer l'entreprise",
  "d8efb0b36d": "Autres",
  "adcb8fbb0c": "Numéro de téléphone courant",
  "eb1c73e2ca": "Veuillez entrer votre numéro de téléphone courant à 11 chiffres",
  "7f276e7dfa": "Création gratuite",
  "c391b3eec1": "Échec de l'envoi du SMS",
  "54f4cb8fa7": "SMS envoyé",
  "231eb1fa1e": "Utilisateur d'entreprise {0}",
  "272b0f9d32": "Utilisateur entreprise",
  "b209a67331": "Échec de la création de l'entreprise, veuillez actualiser la page.",
  "acb08d0cc9": "Troisième étape de la création de l'entreprise",
  "83db361f51": "Après la création, déclencher la logique de redirection",
  "1e930326e3": "handleStep pour passer à l'étape suivante",
  "184df5c725": "Échec de saveForm",
  "736eab3023": "Validation de soumission",
  "2db62dc13c": "Échec de validation",
  "54fb0afaea": "Validation réussie",
  "d39cff3fcf": "Ignorer le cas extrême où une vérification par code est nécessaire",
  "305b777ae5": "Échec de la vérification du nom, ouvrir la fenêtre contextuelle « Nom d'entreprise déjà utilisé » et enregistrer le nom",
  "e57b6686b2": "Vérifiez si l'entité certifiée a déjà été certifiée, ouvrez une fenêtre contextuelle de protection de la certification et enregistrez les informations sur le sujet de certification correspondant",
  "f7c86f496d": "Nom de création en double || Code de vérification expiré. S'il y a un échec de validation, bloquez l'exécution.",
  "cb37db4fd4": "Échec de handleSubmit",
  "243a569fc4": "Ce nom est déjà enregistré, veuillez utiliser un autre nom",
  "196851a3d9": "Utilisateur d'entreprise {0}",
  "0c3a3595ff": "Utilisateur entreprise",
  "a33b41e0f2": "Échec de la création de l'entreprise, veuillez actualiser la page.",
  "fcce6a7156": "Création réussie",
  "5ec6da58a6": "Notifier le client",
  "259c9dfa4e": "Logique version professionnelle",
  "864156930f": "Logique VBA",
  "7824efd172": "AirPage Mobile",
  "52b6cfaaaf": "Client WPS",
  "c7c51beea9": "Version éducation",
  "8d054d4986": "Terminal par défaut",
  "b597e18fb1": "isWps365PcClient et a openurl",
  "b0c13de2a0": "isWps365PcClient ou non-client, a openurl",
  "7d0f2ce18c": "isWps365PcClient ou non-client, a openurl avec succès le retour d'appel",
  "e2c5a07df6": "Non client Non openurl",
  "29e0414d1f": "Non client Non openurl Callback",
  "60861f7d2a": "Autochange à la partie commerciale de changer elle-même",
  "7c83140d90": "Statut invité créé, pas besoin de changer de compte via SDK (SDK ne prend pas en charge les invités), le code a déjà réussi à changer via l'interface",
  "3379b09e59": "Avoir openurl et utiliser href pour changer",
  "586ff04c22": "Redirection séparée",
  "b6c91f218b": "Faille pour useSuccessSkip",
  "47d2f3ba66": "Autre",
  "57551f86ce": "Sélectionnez pour déclencher différentes méthodes selon la source utm",
  "64fe3758e2": "Votre opération n'est pas autorisée",
  "4da3e1262f": "Création réussie, commencez votre voyage d'affaires avec l'entreprise",
  "c38dfb8c6c": "Créez votre premier équipe",
  "38dddb483b": "Entrer dans l'entreprise",
  "614d9c91eb": "Inviter des membres à rejoindre",
  "97f1eca0aa": "Entrer dans l'entreprise",
  "13a4939e90": "Rejoindre l'invitation d'entreprise",
  "a319e4ae0a": "Invitez des collègues à rejoindre",
  "12e4da6bba": "Invitez immédiatement des collègues",
  "bd885380f6": "Échec d'obtention du lien d'invitation",
  "5e626c4063": "SMS envoyé",
  "3dc09e7cfd": "Le nombre de noms d'entreprise que vous avez demandés à récupérer a atteint la limite",
  "48318f41f9": "Inviter des membres à rejoindre",
  "45441baac4": "Invitation à rejoindre {0} pour collaborer",
  "e5847fbd67": "Copiez le lien, invitez des membres",
  "23101dd40a": "En train de personnaliser une solution pour vous",
  "71bb7e54a8": "Gestion de projet",
  "aff37c79cc": "Essayez la solution choisie",
  "a97b174258": "Invitez 2 collègues pour bénéficier gratuitement des avantages de l'entreprise suivants",
  "253855849f": "Partager le lien d'invitation dans le groupe de travail pour inviter des collègues",
  "57b0a2a63f": "Copiez le lien et invitez des collègues",
  "71c0a37ee1": "Entrer dans l'entreprise",
  "f848c60e0e": "Invitez <color:red>2</> collègues de plus à vous rejoindre pour obtenir gratuitement les avantages de l'entreprise suivants",
  "664e32b4fe": "Page d'invitation Entrer dans l'entreprise",
  "872f14403a": "Invitez des collègues à rejoindre",
  "1880e7deb9": "Invitez immédiatement des collègues",
  "cc2a9aaf82": "Création réussie",
  "02a13e2583": "Invitez 2 collègues pour bénéficier gratuitement des avantages de l'entreprise suivants",
  "5d3593cdce": "Échec de l'obtention des informations d'équipe",
  "c025113ea1": "Échec d'obtention du lien d'invitation",
  "b83bc1e485": "Lien d'invitation",
  "0996ced9f6": "Désolé, votre navigateur actuel ne prend pas en charge le téléchargement de ce code QR",
  "1e88451e31": "Lien d'invitation copié",
  "bb969cabcd": "Échec de la copie, veuillez réessayer",
  "15e1f79c7a": "Demander à rejoindre l'entreprise",
  "59c22b4ef8": "Reçu un lien d'invitation",
  "0f0b392e60": "Créez Votre Premier Équipe",
  "0437d07c43": "Nom De L'entreprise",
  "41800c7bf1": "Veuillez Entrer Le Nom Du Créateur",
  "1ec5999511": "Le Nom Du Créateur Ne Doit Pas Dépasser 8 Caractères",
  "02da35b4e4": "Le Nom Du Créateur Ne Peut Contenir Que Des Caractères Chinois, Lettres, Chiffres",
  "184e9f6616": "Veuillez Entrer Le Numéro De Téléphone",
  "9b587898ba": "Veuillez Entrer Un Numéro De Téléphone Valide",
  "e68c164a02": "Veuillez Entrer Votre Adresse E-mail",
  "0b1de22df7": "Veuillez Entrer Une Adresse E-mail Valide",
  "61026181ab": "Licence Commerciale Requise",
  "c3847e604e": "La Taille Du Fichier Dépasse 10 Mo, Veuillez Réessayer",
  "49450f4ec7": "Formulaire De Contestation De Nom Requis",
  "39c3b8fa1d": "Échec De La Soumission",
  "3ea44d7963": "Téléchargement Réussi",
  "5b1aa3c2c4": "Échec Du Téléchargement",
  "7e7f81eaa3": "Échec Du Téléchargement, Fichier Supérieur À 10 Mo",
  "2ff1913de1": "Échec Du Téléchargement, Le Fichier Doit Être .jpg, .jpeg, .png, .bmp, .pdf",
  "7951a879f2": "Licence Commerciale Requise",
  "66bda65057": "La Taille Du Fichier Dépasse 10 Mo, Veuillez Réessayer",
  "8f2305a83d": "Formulaire De Contestation De Nom Requis",
  "55ff0c8c6e": "Échec De La Soumission",
  "8dad6d950d": "Échec De Récupération Des Informations D'invitation",
  "a5f0ac3a9a": "Création Réussie",
  "4f1d069770": "Utm De Page D'invitation Pour {0} Et Nom {1}",
  "f9578cfe6d": "Utm De Guide En Deux Étapes Pour {0} Et Nom {1}",
  "e10d028405": "Guide En Deux Étapes Pcoffice Créé",
  "8e22e4fcc4": "Lien D'invitation Copié",
  "3f327f9f37": "Échec De La Copie, Veuillez Réessayer",
  "bd1aecb265": "Annuler",
  "b6abf9b19a": "Accepter",
  "e910d9cc0f": "Annuler",
  "37ab25522d": "Accepter",
  "196b3eb9cf": "Scannez Pour Rejoindre",
  "2b81c52e20": "Télécharger L'image",
  "62152fd9f3": "Lien D'invitation",
  "e0a3725651": "Désolé, Votre Navigateur Actuel Ne Prend Pas En Charge Le Téléchargement De Ce Code QR",
  "8b7883b2c7": "Scannez Pour Rejoindre",
  "9e9a659ed5": "Télécharger L'image",
  "0d55065a9a": "Lien D'invitation",
  "487cf6a106": "Désolé, Votre Navigateur Actuel Ne Prend Pas En Charge Le Téléchargement De Ce Code QR",
  "78fd005d1f": "Veuillez Entrer Le Numéro De Téléphone",
  "f909563857": "Créer Avec Ce Numéro",
  "a26a19f139": "Annuler La Création",
  "cc004ac9ee": "Numéro De Téléphone",
  "4df8c3c588": "Entrez Un Autre Numéro Pour Créer Une École",
  "3151cabb3d": "Entrez Un Autre Numéro Pour Créer Une Entreprise",
  "56098a71eb": "Cliquez Sur Vérification Intelligente, Envoyer Le Code",
  "e96ec218e4": "Veuillez Entrer Le Code SMS",
  "ce619a0225": "Le Code SMS Est Envoyé À",
  "0e9863aaeb": "Code Incorrect, Veuillez Réessayer",
  "32dc8629e1": "Secondes Avant Le Renvoi",
  "e4eda9add5": "Renvoyer",
  "b007977564": "Échec de l'obtention des informations d'approbation",
  "d8852ffc9c": "Accès non administrateur",
  "8a733a2574": "Accès via mobile",
  "9e8c152c4f": "Accès via PC",
  "2265a55e93": "Accepter le contrat de service",
  "80dabe5aa3": "Créer un guide",
  "7deee8bf5a": "Guide en deux étapes docsWeb créé",
  "69eb501ecb": "Votre requête n'est plus valide, accès impossible",
  "aa1d9d98ad": "Accès refusé, autorisation insuffisante",
  "fdf2fe129e": "Créer Organisme",
  "7f0ca0df6b": "Créer Entreprise",
  "cc6ac2a93c": "Guide En Deux Étapes Bas Monté",
  "5d6c570bf0": "Guide En Deux Étapes Avant Déchargement",
  "a4eb8a192d": "Équipes que tout le monde crée",
  "4912e16a9d": "Nom de l'entreprise récupéré",
  "41c4e87ef2": "Vous pouvez cliquer sur le lien",
  "5e630930c0": "Recréer Entreprise",
  "436a563524": "Si vous avez déjà créé une entreprise, vous pouvez consulter",
  "0b6e7cbe7f": "Comment modifier le nom de l'entreprise",
  "cb7bce0775": "Tutoriel pour modifier le nom de l'entreprise",
  "3feadd3040": "Version actuelle obsolète, entreprise inaccessible",
  "3cf23de936": "Votre version de logiciel est obsolète, fonctionnalité d'entreprise inaccessible. Veuillez mettre à jour votre logiciel via le marché d'applications !",
  "a1c5d5d202": "OK",
  "e50183bd00": "Documents en nuage WPS",
  "e5031ab679": "Sécurité, synchronisation, collaboration",
  "c870026dfc": "Connexion par WeChat",
  "e7647cd875": "Téléphone ou courriel",
  "07b380074b": "Connexion par QQ",
  "67921724dd": "Autres façons",
  "254da8a9f5": "Limite atteinte pour rejoindre/créer des entreprises",
  "3648e4811b": "Accéder aux documents Kingsoft",
  "dcd102b346": "Créer Équipe personnalisée",
  "8b9b258cbf": "Saisissez le nom de l'équipe ici",
  "19bb6e0ded": "Les membres WPS bénéficient de",
  "2d9fe8d938": "Avantages de bureau, aidant à résoudre les problèmes de documents quotidiens, venez les essayer !",
  "e8c1caa649": "Télécharger depuis local",
  "03641083a3": "Déplacer de « Documents personnels »",
  "eecd3ab9b5": "Parler plus tard",
  "13b447b3a8": "Changer de lot",
  "3c2fc507fc": "Version actuelle obsolète, entreprise inaccessible",
  "c3615d8134": "Votre version de logiciel est obsolète, fonctionnalité d'entreprise inaccessible. Veuillez mettre à jour votre logiciel via le site officiel !",
  "644a36e05b": "Mettre à jour",
  "d435105f21": "Limite atteinte pour rejoindre/créer des entreprises",
  "73a286ceb0": "Accéder aux documents Kingsoft",
  "c2cec645c0": "Annuler",
  "b5f5b83c0f": "Accepter",
  "76ec352da5": "Inviter des collègues par code QR",
  "6a509e4487": "Télécharger le code QR",
  "940cc4a546": "Impossible de créer une entreprise",
  "78b2a62ea5": "Accéder à une entreprise existante ou créer une nouvelle entreprise",
  "3a6da7f6f9": "Le nombre actuel d'entreprises liées au numéro de téléphone a atteint la limite (maximum de 5 entreprises)",
  "93bab52870": "Le numéro de téléphone est déjà lié à une entreprise, vous pouvez choisir de vous connecter à une entreprise existante :",
  "ce6e0adaf2": "Vous pouvez choisir d'accéder à l'entreprise liée ci-dessous :",
  "1ce200a92b": "Choisir",
  "bb91ef2999": "Créer Nouvelle Entreprise",
  "024e4a91e5": "Le nom de l'entreprise est déjà enregistré",
  "eb089a23a0": "Ce nom de l'entreprise est déjà enregistré :",
  "7646558701": "Administrateur :",
  "1d9c02bd33": "Date d'inscription :",
  "919fc7805f": "Nous vous suggérons d'essayer de trouver et de contacter vos collègues mentionnés ci-dessus.",
  "0ca71a9344": "Vous pouvez également créer temporairement une entreprise avec un autre nom (modifiable ultérieurement) et soumettre une réclamation.",
  "e83a244e90": "Cliquez pour en savoir plus sur la façon de faire appel.",
  "d22bedfb21": "OK",
  "907b78b6e5": "Entrez le nom du groupe de travail ou de l'équipe",
  "7195b0ac1e": "Équipe que vous pourriez vouloir créer",
  "60ed4f915e": "Suivant",
  "f5ba8dfb7b": "Passer le guide",
  "5c44a3ef68": "Jusqu'à 100 caractères",
  "130c53fb20": "Le nom ne peut pas contenir de caractères illégaux et des symboles spéciaux /\\;:*?\"<>|%&",
  "e832d41acc": "Guidage en deux étapes Passer",
  "80d9cf7177": "Guidage en deux étapes Rafraîchir",
  "0aebf80435": "Guidage en deux étapes Cliquez sur l'étiquette",
  "e74f515977": "Guide en deux étapes pour handleSubmit",
  "308d2a53c9": "Guide en deux étapes pour createGroup",
  "dda2ed7e18": "Guidage en deux étapes Échec de la création de l'équipe",
  "ded3c35500": "Échec de la création de l'équipe",
  "4f18031bc1": "Guide en deux étapes pour createTemplate",
  "091e5cefcc": "Erreur de création de modèle en deux étapes",
  "58cf4e00f0": "Code de vérification",
  "92abbf0385": "Envoyer le code de vérification",
  "f0f9976ef9": "Veuillez entrer le numéro de téléphone",
  "a4ce99b1df": "Code de vérification",
  "39d36e0f9f": "Confirmer",
  "0fd8a01938": "Envoyer",
  "9048a4e842": "Numéro de téléphone",
  "9afa1091eb": "Renvoyer",
  "58d787001f": "Entrez un autre numéro de téléphone pour créer une école",
  "450905a265": "Entrez un autre numéro de téléphone pour créer une entreprise",
  "f7386de3c6": "Choisissez dans le menu déroulant",
  "27aa05a92c": "Accepter les conditions d'utilisation",
  "80af61cb57": "Retour à la page précédente",
  "50149b8d4f": "Nom du demandeur",
  "e6756f8749": "Veuillez entrer votre nom",
  "3cbd51a2b1": "Le nom doit comporter au moins 2 caractères, veuillez entrer un nom de 2 à 10 caractères",
  "4f79b4813f": "Le nom ne prend en charge que les caractères chinois, les chiffres, les lettres anglaises, le point médian",
  "71d3e75983": "Numéro de téléphone habituel",
  "afe5149035": "Veuillez entrer votre numéro de téléphone habituel",
  "1e9270b50f": "Veuillez entrer votre numéro de téléphone habituel, 11 chiffres",
  "ff5dc98dfb": "Passer",
  "165be2ab43": "Retour à l'étape précédente",
  "231d8a335a": "Accepter les conditions d'utilisation",
  "1cad008ffc": "Le nom de l'entreprise {0} est déjà enregistré, veuillez utiliser un autre nom",
  "c6e274fcab": "Confirmation de l'accord",
  "b9352504bb": "Fermer la fenêtre contextuelle de l'accord",
  "8409e99ad0": "Ouvrir la fenêtre contextuelle de l'accord",
  "1593c6dd95": "Soumettre",
  "4f44a9de22": "Ouvrir la vérification par SMS",
  "26b70c68b8": "Passer, accéder directement à l'entreprise",
  "a8bebcb302": "Retour à la page précédente",
  "c800b4fec5": "Page d'invitation Base montée",
  "38b396d5b0": "La page d'invitation à docsWeb montée",
  "2eb7f9a9f1": "Votre réclamation a été soumise avec succès",
  "2c6f3590fb": "Nous prévoyons d'envoyer le résultat de l'analyse à votre courriel dans un délai de 3 jours ouvrables",
  "2ea3eff708": "Veuillez vérifier votre boîte de réception.",
  "53acfba22c": "Inviter des collègues immédiatement",
  "4e6d282f4f": "Rejoindre l'invitation de l'entreprise",
  "5f72f4b936": "Inviter des collègues immédiatement",
  "e5383077ba": "Récupérer le nom de l'entreprise",
  "06e3fa2350": "Après vérification,",
  "653a263b5e": "le créateur est",
  "769f57269f": "Le numéro de téléphone du créateur est",
  "09a224695e": "Veuillez confirmer si ce créateur d'entreprise est votre collègue",
  "3beda6c149": "Si c’est votre collègue, vous pouvez le contacter",
  "5c74dd10d1": "Modifier le nom de l'entreprise ou transférer l'administrateur principal.",
  "da504edb0f": "Si ce n'est pas votre collègue, vous pouvez cliquer sur le bouton ci-dessous pour retrouver le nom de l'entreprise.",
  "39194faaf1": "Continuer à récupérer le nom de l'entreprise",
  "e22b829e90": "Copie réussie",
  "6e1b44752a": "Valeur TXT",
  "79881b1d7a": "Inviter un collègue immédiatement",
  "a5344a45f9": "Cliquez en haut à droite, sélectionnez Envoyer à un ami",
  "a4954a5b08": "Inviter un collègue immédiatement",
  "8e3a1625fb": "Récupérer le nom de l'entreprise",
  "bf8b8c7005": "Télécharger le certificat d'enregistrement de l'entreprise",
  "bfd44a66c9": "Cliquez pour sélectionner",
  "d503f20925": "Veuillez télécharger une copie scannée ou une photo du certificat d'enregistrement de l'entreprise",
  "cbebe043c5": "Formats pris en charge : JPG, JPEG, PNG, BMP, PDF, taille ne dépassant pas 10 MB.",
  "9650b96d7d": "Télécharger le formulaire de plainte pour homonymie",
  "c3b8ae46d3": "Veuillez télécharger une copie scannée ou une photo du formulaire de plainte pour homonymie",
  "9e325a9e09": "Télécharger le modèle de formulaire d'information",
  "a4711aae88": "Soumettre la demande",
  "3a5cc1441e": "En cours de vérification...",
  "0bd7bf8511": "Nous ne pouvons actuellement pas vérifier votre domaine. Vous devrez peut-être attendre un moment pour que le fournisseur de services de domaine mette à jour vos informations. Si après un certain temps, il n'y a toujours pas de réaction, veuillez tenter de le vérifier à nouveau ou changer de domaine.",
  "fae48d554b": "Vérification du domaine",
  "5e1779a0ca": "de l'enregistrement de vérification, vous pouvez fermer cette page et revenir plus tard pour vérifier.",
  "ca85f8b836": "Bienvenue dans la version entreprise",
  "2570e0f00b": "Échec de la connexion",
  "40d16a007e": "Votre compte personnel a été automatiquement lié",
  "81376b92e4": "Mode de connexion de {0}, veuillez vous reconnecter pour passer au compte entreprise.",
  "ba679ba739": "Compris, se connecter",
  "c05f64c6c6": "Après {0}, aller automatiquement à la connexion",
  "c329ccef3a": "Échec de la connexion",
  "e370f9afb1": "Votre compte personnel a été automatiquement lié",
  "410cf42585": "Veuillez vous reconnecter pour changer de compte entreprise.",
  "062d48aece": "Compris, se connecter",
  "95a105d412": "Aller automatiquement à la connexion après",
  "2d000d5a6d": "Envoyer le lien de partage aux membres, qui peuvent demander à rejoindre après l'ouverture",
  "8861b6e90d": "Accéder à l'entreprise",
  "25b9f72fda": "Erreur de paramètre de page",
  "1c76123efc": "Échec de l'obtention du lien d'invitation",
  "6caba48b76": "Passer",
  "f66379c650": "Erreur de paramètre de page",
  "c45021de2a": "Échec de la création",
  "011d470126": "La plateforme protège en continu votre sécurité des informations",
  "f1a44d9151": "La plateforme a obtenu les certificats ISO27001 et ISO27701 décernés par le BSI international, et a passé l'évaluation de sécurité de niveau trois nationale--",
  "255ea5dff7": "Livre blanc sur la sécurité",
  "bb55b124f2": "Créer une Démonstration d'Entreprise",
  "61e24974a3": "Créer un Contenu de Stratégie d'Acquisition d'Entreprise",
  "bfdf78febe": "Prochaine Étape pour Compléter les Informations",
  "c4aa2d2d60": "Entrez le Nom du Groupe de Travail ou du Projet",
  "b69765ab64": "Équipes Créées par Tous",
  "9657d9408b": "Change le Lot",
  "e21da8c16a": "Prochain",
  "224ef5cc9f": "Passer l'Introduction",
  "641f58c8f6": "L'entreprise Actuelle ne Permet Pas aux Membres de Créer des Équipes, Veuillez Pratiquer l'Administrateur Créateur",
  "efea622752": "Copier le Lien, Inviter des Collègues",
  "fd5b40a9fd": "Vous inviter à rejoindre « {0} », Travailler Ensemble",
  "b04dd2f10a": "Lien d'Invitation Copié",
  "d1606a1b1a": "Échec de la Copie, Veuillez Réessayer",
  "0d59f3db83": "Entrez le Département de Projet ou l'Équipe, comme « Département des Ventes »",
  "9429513d34": "Pas Besoin d'Introduction",
  "b54a20b1ff": "Échec de la Création",
  "093fa0fb74": "Autorisation de Connexion en Cours...",
  "b383b136f4": "Initialisation du Projet de l'Entreprise",
  "b6b21b388b": "Nom d'Entreprise déjà Enregistré",
  "285dc68c10": "Le Nom de l'Entreprise a déjà été Enregistré :",
  "1bf685b89d": "Administrateur :",
  "7b4297edcc": "Date d'Inscription :",
  "fa51ea19fc": "Nous vous conseillons de chercher et de contacter vos collègues mentionnés ci-dessus.",
  "e3678a996d": "Vous pouvez également créer temporairement une entreprise avec un autre nom (modifiable plus tard) et soumettre une plainte.",
  "5969bc8071": "D'accord",
  "ba4cf699df": "Récupérer le Nom de l'Entreprise",
  "afecee4eb4": "Votre Nom",
  "a8bdebc614": "Veuillez entrer votre nom",
  "5bbeb38a66": "Téléphone",
  "b4f7b44b7a": "Veuillez entrer votre numéro de téléphone",
  "cac2913686": "Courriel",
  "23d3bb3a42": "Veuillez entrer votre courriel",
  "ea106a393c": "Télécharger le Certificat de Registre d'Entreprise",
  "f74131d71e": "Cliquez pour Sélectionner",
  "53749c51c5": "Veuillez télécharger le scan ou la photo du certificat de registre d'entreprise",
  "c00f2ea171": "Formats pris en charge : JPG, JPEG, PNG, BMP, PDF, Taille maximale de 10 MB.",
  "57ec07fa97": "Télécharger le Formulaire de Contestation de Noms Doublons",
  "8eb0606e94": "Veuillez télécharger le scan ou la photo du formulaire de contestation de noms doublons",
  "f59e76c0b0": "Télécharger le Modèle de Formulaire",
  "030bd26fa4": "Soumettre la Demande",
  "0a602dc727": "Stockage Sécurisé des Informations",
  "9138f28acf": "Collaboration et Partage de Fichiers",
  "b3a306cf90": "Conformité et Légalisation",
  "973c53f725": "Il est recommandé de Modifier le Nom, Vous Pouvez Soumettre une Certification de l'Institution Après l'Enregistrement et Mettre à Jour le Nom",
  "f886f5e92f": "Il est recommandé de Modifier le Nom, Vous Pouvez Soumettre une Certification de l'Entreprise Après l'Enregistrement et Mettre à Jour le Nom",
  "b8051702a3": "Ce nom contient des termes sensibles, Veuillez ajuster le nom ou contacter le personnel du service client",
  "d73881f7d4": "Nom d'Entreprise Protégé",
  "dc7e58e320": "Nom d'Entreprise Protégé, Vérification des Informations de l'Entreprise requise avant utilisation. Il est recommandé de modifier le nom de l'entreprise, ou d'utiliser le nom après enregistrement et certification d'entreprise.",
  "20c3bc070c": "Confirmer",
  "c4278e5f28": "Autorisations insuffisantes",
  "9217efae21": "Le compte auquel vous êtes connecté n'a pas les autorisations nécessaires pour créer, veuillez contacter le personnel de vente pour assistance",
  "52ff08f2ad": "Le nom de l'agence est protégé, veuillez ajuster le nom de l'entreprise",
  "79386ae280": "Veuillez entrer un code de vérification à 6 chiffres",
  "d7b2c5a41b": "Le code de vérification a été envoyé à",
  "ce2e1c26f7": "(Valide pendant 10 minutes)",
  "59d338903f": "Code de vérification récupérable dans {0} secondes",
  "5aadd14136": "Récupérer le code de vérification",
  "90f5c93432": "Ce nom est déjà enregistré",
  "1677072f4a": "Vous pouvez fournir plus d'informations ou utiliser un autre nom pour vous enregistrer",
  "3b8459fb1e": "Remplissage rapide :",
  "6f38edbcb1": "Inscrire avec ce nom",
  "8406c81e2d": "Succursale",
  "29d323fa85": "Centre secondaire",
  "4f0e806e02": "Département des finances",
  "3f935efb6b": "Accepter l'accord de service",
  "b42241be05": "Pas maintenant",
  "99de4b33b7": "Accepter",
  "7f867e7395": "Utiliser un autre numéro de téléphone pour créer l'entreprise",
  "0d51a8f7a6": "Continuer à créer",
  "8bdaecf2e5": "Veuillez entrer votre numéro de téléphone",
  "565ae60c8a": "Veuillez entrer votre nom",
  "f76e06d0e7": "Veuillez entrer votre numéro de téléphone",
  "7b0fca5255": "Veuillez entrer le code de vérification",
  "68026d2d25": "Bienvenue dans la version Entreprise",
  "d25b5541be": "Création gratuite",
  "32cfd73733": "Veuillez entrer le nom de l'équipe, de l'entreprise ou de l'organisation",
  "4cf83dc4a0": "Création rapide en une minute, collaborer efficacement avec les collègues",
  "d320d37116": "Création gratuite de l'équipe/entreprise",
  "c54b475dd2": "Accord utilisateur",
  "190d54e616": "Entreprise de {0}",
  "8c1b768ac4": "Échec de la vérification intelligente",
  "d74eab0f35": "Les informations de nom de votre entreprise ne sont pas conformes aux normes de la plateforme, veuillez modifier et réessayer",
  "0f3d62dd4f": "Les informations de nom ne sont pas conformes aux normes de la plateforme, veuillez modifier et réessayer",
  "647cf2211b": "Numéro de téléphone actuel non pris en charge, veuillez le changer",
  "b63d96cdae": "Les informations fournies ne sont pas conformes aux normes de la plateforme, veuillez modifier et réessayer",
  "2dbbe8e43f": "Numéro de téléphone actuel non pris en charge, veuillez modifier et réessayer",
  "b18abc5de6": "Aucun numéro de téléphone lié",
  "f5233dae6f": "Veuillez changer de numéro de téléphone pour créer",
  "4167c8b88d": "Le numéro de téléphone actuel pourrait présenter le problème suivant, veuillez essayer un autre numéro pour le créer. En cas de doute, veuillez contacter le service clientèle",
  "a8a2433c4d": "Scanner avec WeChat pour ajouter et contacter le service clientèle",
  "444a639c09": "J'ai compris",
  "69a097057f": "Le numéro de téléphone actuel appartient à un opérateur de téléphonie virtuelle <#BB2726>",
  "4370b06fd0": "Le numéro de téléphone actuel présente un comportement d'utilisation anormal <#BB2726>",
  "8c49e1dc4a": "Une vérification homme-machine est nécessaire",
  "4b8ba7d8cc": "Nouvelle plateforme de productivité de bureau",
  "81be771e17": "🎉Succès De La Création De L'entreprise ! Complétez Les Informations Pour Accéder À Des Services Exclusifs",
  "461125b057": "Vous pouvez gérer des documents et des informations au sein de l'équipe. Les membres de l'équipe peuvent facilement les consulter, et vous pouvez définir des autorisations de modification/téléchargement pour garantir la sécurité des données.",
  "c3eb25029b": "Taille de l'entreprise/équipe",
  "049f8401ec": "Moins de 5 personnes",
  "c81896349e": "6-20 personnes",
  "7357daac4e": "21-50 personnes",
  "f0e65a0a29": "51-100 personnes",
  "b9fac8204a": "101-200 personnes",
  "62d73dddaf": "201-500 personnes",
  "3bcdaf7160": "501-2000 personnes",
  "ab0b2333fe": "Plus de 2000 personnes",
  "4f756eedc8": "Votre rôle est",
  "3ba0b502c3": "Directeur général",
  "702099cc72": "Financier",
  "843b603162": "Achats",
  "8b414a9b44": "Ressources humaines/Administratif",
  "92486b2908": "Ventes",
  "ac4e7fb063": "Votre organisation a-t-elle un budget/plan d'achat pour les logiciels bureautiques",
  "37634c72dc": "Dans les 6 mois",
  "bd94b6deec": "Dans un an",
  "713f4aad5c": "En cours de considération",
  "c5ea095a4d": "Pas de plan pour le moment",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Créez Une Équipe Et Invitez Des Membres À Collaborer Ensemble",
  "9d27dc2d90": "Vous pouvez entrer le nom de l'équipe ou le projet récemment suivi",
  "de19c8509a": "Vous pourriez créer :",
  "1a84699223": "Département des ventes",
  "efab59502b": "Département des produits",
  "7e599b3713": "Opérations Sud",
  "bf494779c2": "Département des achats",
  "f3a60ab34d": "Département administratif",
  "bbc50c1ac8": "Finance Nord",
  "32629e3dac": "Finance des produits",
  "5524d354ba": "Département IT",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>Vous Avez Débloqué Les Avantages Pour Débutants !</span> Invitez Encore 3 Personnes Pour Obtenir <span style='color: rgb(206,131,62);'>4T D'espace, Les Avantages WPS AI</span>",
  "939eb98492": "<span style='color: rgb(206,131,62);'>Vous Avez Débloqué La Limite De 50 Personnes, Droit À Un Téléchargement Unique De 4 Go</span>. Continuez À Inviter 3 Personnes Pour Débloquer 30 Jours De WPS AI Et Les Avantages Super 4T D'espace",
  "136c26d941": "Copiez le lien ci-dessous et invitez des membres à rejoindre",
  "3de5c12558": "Copiez le lien et invitez des collègues",
  "a5d64b14f3": "Guide d'information sur l'entreprise",
  "b8f2492701": "Collecte d'informations sur l'entreprise",
  "1f9d053dc0": "Créer un modèle d'équipe",
  "0e83c79a88": "Inviter des membres",
  "821fc1906a": "Entrer dans l'entreprise",
  "463e14ae9c": "Veuillez sélectionner une équipe",
  "690f0cdb9e": "Icône de fin",
  "c340522a17": "Étape précédente",
  "f9355c72ef": "Sauter",
  "bd6c09ebbb": "Étape suivante",
  "2a2603cd3f": "Envoyez une invitation scannée à vos collègues",
  "411e64907a": "Copier",
  "b0d988cf23": "Télécharger",
  "e3c0b650ac": "Copie réussie",
  "713ac624b4": "Bienvenue à WPS 365",
  "b8fff97849": "Élément cible invalide",
  "02acdcf296": "Échec de la conversion html2canvas, canvas non généré",
  "a76988c496": "Échec de la conversion du canvas en blob",
  "af89584edf": "API du presse-papiers non disponible",
  "f90263bbde": "Échec de la copie de l'image",
  "71b05319da": "Échec de la conversion du HTML en canvas",
  "38852999fe": "Échec de l'enregistrement des informations",
  "4a4c621d07": "Échec de la création de l'équipe, veuillez réessayer plus tard",
  "d239a23994": "Cette page est réservée aux comptes d'entreprise, veuillez d'abord vous connecter avec un compte d'entreprise.",
  "d93bfb7fb9": "Veuillez entrer le contenu",
  "42b81a66c4": "Longueur de 2 à 100 caractères",
  "76d33733db": "Ne peut pas contenir / \\ ; : * ? \" < > | % & et autres caractères spéciaux",
  "dc55d1f62f": "Aller à l'expérience",
  "b25233cba0": "Collaborer Sur Les Documents + Messagerie Instantanée, Lancez Une Nouvelle Façon Efficace De Travailler",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Commencez Les Chats En Équipe, Partage De Documents Sécurisé Et Pratique",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Assistant Lingxi AI, L'assistant Intelligent Conçu Pour Le Bureau",
  "e338385bc9": "Office Intelligence native, intégration profonde de l'IA et du logiciel de bureau, permettant à chacun d'avoir un assistant IA",
  "7ae1f3b1c6": "L'importation de fichier(s) est terminée, vous pouvez consulter le résultat dans « Mon Cloud Document »",
  "85db2a024a": "Échec d'importation de fichiers (dossiers), veuillez réessayer plus tard",
  "9ff74c802a": "Télécharger la version pour puce Intel",
  "ab44928f02": "Télécharger la version pour puce Apple",
  "a08d937c38": "Fichier(s) en cours de téléchargement, vous pourrez voir le résultat dans « Mon Cloud Document » une fois terminé",
  "68db1829fa": "Seulement pris en charge pour l'importation depuis un compte personnel; veuillez vous connecter à votre compte personnel et réessayer.",
  "1185a7c7ab": "Moins de 20 personnes",
  "e2bcc252c9": "21-300 personnes",
  "3c4842f1ea": "301-1000 personnes",
  "1bbee64cfa": "Plus de 1000 personnes",
  "388ff4a035": "Enseignant",
  "d341b1d794": "Étudiant",
  "bfb2ee4148": "Autre",
  "f6450c3f31": "Gestion de projet",
  "b87fd33a0d": "Plan annuel",
  "0dd45a1c14": "Gestion de la performance des employés",
  "67fa01cac6": "Activités de marketing",
  "6dd82cc031": "Recrutement des employés",
  "a7edaed91d": "Support de cours",
  "bf12b7efb0": "Gestion du plan de cours",
  "c35ae8f358": "Documentation produit",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> Tableur multidimensionnel WPS, création visuelle de système d'affaires personnalisé",
  "72286d5519": "👏Modèles recommandés",
  "0bc00ee949": "Gestion des exigences et défauts",
  "e22f3d56f7": "Gestion de la création de contenu",
  "dd439de3dd": "Système de gestion de la clientèle",
  "fbb2bbf82e": "Plan d'étude",
  "0645b908bc": "Consultation de la feuille de paie",
  "813b3d3d7e": "Gestion OKR",
  "918e33d5bd": "Créez en un clic",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Importer des documents courants pour une utilisation plus pratique",
  "c58f28713c": "Importer depuis un périphérique local",
  "9d6a0a4370": "Prise en charge des formats de fichiers courants Office",
  "54c48aee85": "Sélectionner un fichier",
  "c5b593e452": "Importer depuis un compte personnel",
  "4bdcd9d4c5": "Importer en un clic les documents, équipes, et dossiers du compte personnel",
  "99b2968905": "Autoriser l'Importation",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Télécharger le Client WPS Teams",
  "fe46574227": "Collaboration de Documents + Messages Instantanés, Une Nouvelle Méthode de Travail Efficace",
  "beefe5a09b": "Télécharger Maintenant",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Paramètres Sécurisés Riches, Garantissent la Sécurité des Données",
  "b4e70dbeab": "WPS Accumulation de Capacité de Sécurité des Documents Pendant des Années, Garantissent que Les Données Clés de l'Entreprise Ne Fuient Pas",
  "42dc772619": "Fichier trop volumineux, veuillez essayer d'importer sur la page d'accueil plus tard",
  "a052564e47": "Échec de Création, Veuillez Réessayer Plus Tard",
  "790d0c428c": "Accéder au Poste de Travail"
}